import { useEffect, useState } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function ChauffagePage() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Installation Chauffage Valence | Chaudière, Pompe à Chaleur | Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Chauffagiste à Valence : installation chaudière gaz condensation, pompe à chaleur air-eau, chauffage central. Ion Certan, artisan qualifié. Devis gratuit, intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/chauffage');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const solutions = [
    {
      titre: 'Chaudière Gaz Condensation',
      badge: 'Économique',
      description: 'Solution performante pour les logements raccordés au gaz de ville',
      points: [
        'Rendement jusqu\'à 110%',
        'Économies jusqu\'à 30%',
        'Éligible MaPrimeRénov',
        'Installation rapide'
      ],
      image: 'https://public.readdy.ai/ai/img_res/343308486fee8363ebf30d0cee5a8607.jpg'
    },
    {
      titre: 'Pompe à Chaleur Air-Eau',
      badge: 'Écologique',
      description: 'Système écologique utilisant les calories de l\'air extérieur',
      points: [
        'COP jusqu\'à 4',
        'Divise vos factures par 3',
        'Aides financières importantes',
        'Chauffage + climatisation'
      ],
      image: 'https://readdy.ai/api/search-image?query=modern%20air%20source%20heat%20pump%20outdoor%20unit%20installed%20beside%20contemporary%20house%20wall%20clean%20professional%20installation%20heating%20cooling%20system%20realistic%20detailed%20photography%20simple%20background&width=600&height=400&seq=chauff-pac-air-eau-2025&orientation=landscape'
    },
    {
      titre: 'Chauffage Central Complet',
      badge: 'Confort Total',
      description: 'Installation complète avec chaudière, tuyauterie et radiateurs',
      points: [
        'Solution clé en main',
        'Chaleur homogène',
        'Régulation pièce par pièce',
        'Durabilité garantie'
      ],
      image: 'https://readdy.ai/api/search-image?query=modern%20central%20heating%20radiator%20white%20contemporary%20interior%20room%20clean%20minimalist%20design%20home%20comfort%20heating%20system%20professional%20photography%20simple%20background%20realistic%20detailed&width=600&height=400&seq=chauff-central-2025&orientation=landscape'
    }
  ];

  const marques = [
    { nom: 'Saunier Duval', note: 5 },
    { nom: 'De Dietrich', note: 5 },
    { nom: 'Viessmann', note: 5 },
    { nom: 'Atlantic', note: 5 },
    { nom: 'Vaillant', note: 5 },
    { nom: 'Bosch', note: 5 }
  ];

  const temoignages = [
    {
      nom: 'Isabelle R.',
      ville: 'Valence',
      note: 5,
      texte: 'Installation d\'une pompe à chaleur air-eau impeccable. Ion a pris le temps de bien dimensionner le système et de tout m\'expliquer. Mes factures ont été divisées par 3 ! Je recommande vivement.'
    },
    {
      nom: 'Franck M.',
      ville: 'Bourg-lès-Valence',
      note: 5,
      texte: 'Remplacement de ma vieille chaudière par une chaudière à condensation. Travail soigné, propre et rapide. Les économies sont déjà visibles sur ma facture de gaz. Merci pour votre professionnalisme.'
    },
    {
      nom: 'Aurélie C.',
      ville: 'Guilherand-Granges',
      note: 5,
      texte: 'Installation complète d\'un chauffage central dans notre maison. Ion a géré tout le projet de A à Z. Résultat parfait, nous avons enfin une chaleur homogène dans toutes les pièces !'
    }
  ];

  const faqs = [
    {
      question: 'Quel système de chauffage choisir pour ma maison à Valence ?',
      answer: 'Le choix dépend de plusieurs critères : surface à chauffer, isolation, budget, énergie disponible. Pour une maison bien isolée, une pompe à chaleur air-eau est idéale (économies importantes). Si vous êtes raccordé au gaz, une chaudière à condensation offre un excellent rendement. Pour un appartement, des radiateurs électriques à inertie peuvent suffire. Je vous conseille gratuitement lors de la visite.'
    },
    {
      question: 'Combien coûte l\'installation d\'un chauffage central à Valence ?',
      answer: 'Le prix varie selon le système choisi et la configuration de votre logement. Des aides financières (MaPrimeRénov, CEE) peuvent réduire significativement le coût selon votre situation. Je vous fournis un devis gratuit et détaillé après visite.'
    },
    {
      question: 'L\'entretien de chaudière est-il obligatoire ?',
      answer: 'Oui, l\'entretien annuel de chaudière est obligatoire depuis 2009. Cette maintenance assure votre sécurité, optimise les performances, prolonge la durée de vie et maintient la garantie constructeur. Je réalise cet entretien à Valence et alentour avec délivrance d\'une attestation conforme. Possibilité de contrat annuel pour ne rien oublier.'
    },
    {
      question: 'Quelles aides financières pour installer un chauffage à Valence ?',
      answer: 'Plusieurs aides existent : MaPrimeRénov, Certificats d\'Économies d\'Énergie (CEE), TVA réduite à 5,5%, Éco-PTZ. Les conditions varient selon vos revenus et le type d\'équipement. Renseignez-vous auprès de l\'ANAH ou de votre fournisseur d\'énergie pour connaître votre éligibilité.'
    },
    {
      question: 'Intervenez-vous pour un dépannage de chauffage en urgence ?',
      answer: 'Oui, j\'interviens rapidement à Valence, Bourg-lès-Valence, Guilherand-Granges et Portes-lès-Valence pour tout dépannage de chauffage. Chaudière en panne, radiateurs froids, fuite sur le circuit : je diagnostique et répare dans les meilleurs délais pour rétablir votre confort, surtout en période hivernale.'
    },
    {
      question: 'Quelle est la durée de vie d\'une pompe à chaleur ?',
      answer: 'Une pompe à chaleur bien entretenue dure 15 à 20 ans. Pour garantir sa longévité et ses performances, un entretien annuel est indispensable : nettoyage des filtres, contrôle du fluide frigorigène, vérification des connexions électriques. Je propose des contrats d\'entretien pour votre tranquillité.'
    }
  ];

  const avantages = [
    {
      icon: 'ri-fire-line',
      title: 'Chaleur Homogène',
      description: 'Diffusion uniforme de la chaleur dans toutes les pièces pour un confort optimal'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Économies Garanties',
      description: 'Réduisez jusqu\'à 40% vos factures avec des systèmes haute performance'
    },
    {
      icon: 'ri-plant-line',
      title: 'Écologique',
      description: 'Solutions respectueuses de l\'environnement avec pompes à chaleur et chaudières basse consommation'
    },
    {
      icon: 'ri-tools-line',
      title: 'Installation Rapide',
      description: 'Pose professionnelle avec mise en service et réglages personnalisés'
    }
  ];

  const processus = [
    {
      numero: '01',
      titre: 'Étude Thermique',
      description: 'Analyse de votre logement pour dimensionner le système de chauffage adapté'
    },
    {
      numero: '02',
      titre: 'Choix du Système',
      description: 'Conseil personnalisé selon votre budget et vos besoins énergétiques'
    },
    {
      numero: '03',
      titre: 'Installation',
      description: 'Pose professionnelle de la chaudière, radiateurs et raccordements'
    },
    {
      numero: '04',
      titre: 'Mise en Service',
      description: 'Réglages, tests et explications sur l\'utilisation de votre nouveau chauffage'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={true} />
      
      {/* Hero Section avec image de fond */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-24 min-h-[500px] sm:min-h-[600px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20heating%20system%20installation%20contemporary%20home%20interior%20warm%20cozy%20atmosphere%20professional%20technician%20working%20clean%20bright%20space%20natural%20light%20high%20quality%20photography%20realistic%20detailed&width=1920&height=800&seq=chauff-hero-bg-2025&orientation=landscape"
            alt="Installation chauffage Valence"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 w-full">
          <div className="max-w-2xl">
            <div className="inline-block bg-orange-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              Installation & Dépannage
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Installation Chauffage à Valence
            </h1>
            <p className="text-base sm:text-xl text-gray-100 mb-6 sm:mb-8 leading-relaxed">
              Plombier chauffagiste à Valence, j'installe votre système de chauffage pour un confort thermique optimal et des économies d'énergie. Chaudière gaz, pompe à chaleur, chauffage central : solutions performantes à Valence et alentour.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 mb-6 sm:mb-8">
              <a
                href="tel:+33760705475"
                className="bg-orange-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-medium hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <i className="ri-phone-line text-lg sm:text-xl"></i>
                07 60 70 54 75
              </a>
              <a
                href="mailto:ioncertanpro@gmail.com"
                className="bg-white text-orange-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <i className="ri-mail-line text-lg sm:text-xl"></i>
                Demander un devis
              </a>
            </div>
            
            {/* Badges de réassurance */}
            <div className="flex flex-wrap gap-2 sm:gap-4">
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg">
                <i className="ri-checkbox-circle-line text-orange-400 text-base sm:text-xl"></i>
                <span className="text-white text-xs sm:text-sm font-medium">Diagnostic gratuit</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg">
                <i className="ri-time-line text-orange-400 text-base sm:text-xl"></i>
                <span className="text-white text-xs sm:text-sm font-medium">Intervention rapide</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg">
                <i className="ri-shield-check-line text-orange-400 text-base sm:text-xl"></i>
                <span className="text-white text-xs sm:text-sm font-medium">Garantie décennale</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="bg-gray-50 py-3 sm:py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-600">
            <a href="/" className="hover:text-orange-600 transition-colors cursor-pointer">Accueil</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">Installation Chauffage</span>
          </div>
        </div>
      </section>

      {/* Nos Solutions de Chauffage */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Nos Solutions de Chauffage</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Des systèmes performants adaptés à tous les logements et tous les budgets
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {solutions.map((solution, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow border border-gray-100">
                <div className="relative h-40 sm:h-48 w-full">
                  <img
                    src={solution.image}
                    alt={solution.titre}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 sm:top-4 right-3 sm:right-4">
                    <span className="bg-orange-600 text-white px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-semibold">
                      {solution.badge}
                    </span>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{solution.titre}</h3>
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 leading-relaxed">{solution.description}</p>
                  <ul className="space-y-1.5 sm:space-y-2">
                    {solution.points.map((point, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-xs sm:text-sm text-gray-700">
                        <i className="ri-check-line text-orange-600 mt-0.5 flex-shrink-0"></i>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Pourquoi Choisir Nos Systèmes de Chauffage ?</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Des installations performantes pour votre confort et vos économies
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
            {avantages.map((avantage, index) => (
              <div key={index} className="bg-white p-5 sm:p-6 rounded-xl hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-200 rounded-lg mb-3 sm:mb-4">
                  <i className={`${avantage.icon} text-2xl sm:text-3xl text-orange-600`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{avantage.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Notre Processus d'Installation</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Une méthode rigoureuse pour une installation réussie
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 relative">
            {processus.map((etape, index) => (
              <div key={index} className="relative text-center">
                <div className="bg-gradient-to-br from-orange-600 to-orange-700 text-white text-xl sm:text-2xl font-bold w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto shadow-lg relative z-10">
                  {etape.numero}
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{etape.titre}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{etape.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Marques installées */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Marques Installées</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Nous travaillons avec les meilleures marques du marché
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
            {marques.map((marque, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-sm hover:shadow-lg transition-shadow text-center">
                <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-1 sm:mb-2">{marque.nom}</h3>
                <div className="flex justify-center gap-0.5 sm:gap-1">
                  {[...Array(marque.note)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xs sm:text-sm"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contenu SEO Principal */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Installation de Chauffage à Valence : Votre Chauffagiste Local</h2>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <p className="leading-relaxed">
              Vous cherchez un <strong>chauffagiste à Valence</strong> pour installer ou remplacer votre système de chauffage ? En tant que <strong>plombier chauffagiste professionnel</strong>, je vous accompagne dans votre projet pour améliorer votre confort thermique et réduire vos factures énergétiques. Que vous souhaitiez installer une <strong>chaudière gaz</strong>, une <strong>pompe à chaleur</strong> ou un <strong>chauffage central complet</strong>, je vous propose des solutions performantes et économiques.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Chaudière Gaz à Condensation : Performance et Économies</h3>
            <p className="leading-relaxed">
              La <strong>chaudière gaz à condensation</strong> est le système le plus performant pour les logements raccordés au gaz de ville. Avec un rendement supérieur à 100%, elle récupère la chaleur des fumées pour chauffer l'eau du circuit. Résultat : jusqu'à 30% d'économies par rapport à une chaudière classique. J'installe des marques reconnues (Saunier Duval, De Dietrich, Viessmann) avec garantie constructeur. Ce type de chaudière est éligible aux aides <strong>MaPrimeRénov</strong> pour réduire le coût d'installation.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Pompe à Chaleur Air-Eau : Le Chauffage Écologique</h3>
            <p className="leading-relaxed">
              La <strong>pompe à chaleur air-eau</strong> est la solution idéale pour une <strong>rénovation énergétique</strong>. Elle capte les calories présentes dans l'air extérieur pour chauffer votre logement. Avec un COP (Coefficient de Performance) de 3 à 4, elle produit 3 à 4 fois plus d'énergie qu'elle n'en consomme. Très économique à l'usage, elle peut diviser vos factures de chauffage par 3. J'installe des PAC air-eau à <strong>Valence, Bourg-lès-Valence et Guilherand-Granges</strong> avec dimensionnement précis selon votre logement.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Installation de Chauffage Central</h3>
            <p className="leading-relaxed">
              L'<strong>installation d'un chauffage central</strong> comprend la pose de la chaudière, le réseau de tuyauterie, les radiateurs et le système de régulation. Je réalise une installation complète clé en main : étude thermique, dimensionnement, pose, raccordements, mise en service et réglages. Chaque radiateur est équipé de robinets thermostatiques pour réguler la température pièce par pièce et optimiser votre consommation.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Entretien Annuel de Chaudière Obligatoire</h3>
            <p className="leading-relaxed">
              L'<strong>entretien de chaudière</strong> est obligatoire chaque année. Cette maintenance préventive assure votre sécurité (détection de fuite de monoxyde de carbone), optimise les performances (jusqu'à 12% d'économies), prolonge la durée de vie de votre équipement et maintient la garantie constructeur. Je réalise cet entretien à <strong>Valence et communes alentour</strong> avec délivrance d'une attestation conforme. Possibilité de contrat annuel pour ne jamais oublier cette obligation.
            </p>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Ils Nous Font Confiance</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Découvrez les avis de nos clients satisfaits à Valence et alentour
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {temoignages.map((temoignage, index) => (
              <div key={index} className="bg-white p-5 sm:p-8 rounded-xl shadow-lg">
                <div className="flex items-center gap-1 mb-3 sm:mb-4">
                  {[...Array(temoignage.note)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-700 mb-4 sm:mb-6 leading-relaxed italic">"{temoignage.texte}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-100 rounded-full">
                    <i className="ri-user-line text-orange-600 text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-xs sm:text-sm">{temoignage.nom}</p>
                    <p className="text-xs text-gray-600">{temoignage.ville}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Interactive */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Questions Fréquentes</h2>
            <p className="text-lg text-gray-600">
              Tout ce que vous devez savoir sur l'installation de chauffage à Valence
            </p>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <h3 className="text-base font-bold text-gray-900 pr-4">{faq.question}</h3>
                  <i className={`ri-arrow-${openFaqIndex === index ? 'up' : 'down'}-s-line text-2xl text-orange-600 flex-shrink-0`}></i>
                </button>
                {openFaqIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final avec image de fond */}
      <section className="relative py-16 sm:py-24">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20cozy%20home%20interior%20modern%20heating%20radiator%20comfortable%20living%20room%20soft%20lighting%20inviting%20atmosphere%20professional%20photography%20realistic%20detailed%20high%20quality&width=1920&height=600&seq=chauff-cta-bg-2025&orientation=landscape"
            alt="Confort chauffage Valence"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-orange-600/95 to-orange-700/90"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">Besoin d'un Chauffage à Valence ?</h2>
          <p className="text-base sm:text-xl text-orange-50 mb-6 sm:mb-8">
            Contactez-moi pour une étude gratuite et un devis personnalisé
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
            <a
              href="tel:+33760705475"
              className="bg-white text-orange-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg"
            >
              <i className="ri-phone-line text-lg sm:text-xl"></i>
              Appeler maintenant
            </a>
            <a
              href="mailto:ioncertanpro@gmail.com"
              className="bg-orange-800 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-medium hover:bg-orange-900 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 shadow-lg"
            >
              <i className="ri-mail-line text-lg sm:text-xl"></i>
              Demander un devis
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}